import { Container, Row, Badge, Media, NavItem, NavLink, Nav, TabContent, TabPane, List } from 'reactstrap';
import React, { useState } from 'react';
import classnames from 'classnames';
import UnitReviews from './ReviewComponent';
import SkeletonImage from '../SkeletonImage';

export function RenderTrue({unitTrue, trueReview = false, onViewStats}) {
    //Hook for Tab State
    const [currentTab, setCurrentTab] = useState('1');

    //Toggle Tab for Global TW
    const toggle = tab => {
        if(currentTab !== tab) setCurrentTab(tab);
    }

    const [serverTab, setServerTab] = useState('1');

    //Toggle for Different Server Stats
    const serverToggle = tab => {
        if(serverTab !== tab) setServerTab(tab)
    }

    const tw = unitTrue.trueweapon;
    const jp = unitTrue.trueweaponJP;

    return (
        <div className="gs-unit-detail gs-unit-true">
            <Container>
            { (tw || jp) ? 
                <>
                    { tw?.true1 ? 
                        <>
                            <Nav pills justified className="gs-tabs gs-tabs--thumbs">
                                <NavItem>
                                    <NavLink className={classnames({ active: currentTab === '1' })}
                                        onClick={() => {toggle('1')}}>
                                        <SkeletonImage
                                            src={tw.true1.thumb}
                                            alt=""
                                            frameClassName="gs-skeleton-frame--detail-thumb"
                                            loading="lazy"
                                        />
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames({ active: currentTab === '2' })}
                                        onClick={() => {toggle('2')}}>
                                        <SkeletonImage
                                            src={tw.true2.thumb}
                                            alt=""
                                            frameClassName="gs-skeleton-frame--detail-thumb"
                                            loading="lazy"
                                        />
                                    </NavLink>
                                </NavItem>
                                {
                                    tw.true3 ? 
                                    <NavItem>
                                        <NavLink className={classnames({ active: currentTab === '3' })}
                                            onClick={() => {toggle('3')}}>
                                            <SkeletonImage
                                                src={tw.true3.thumb}
                                                alt=""
                                                frameClassName="gs-skeleton-frame--detail-thumb"
                                                loading="lazy"
                                            />
                                        </NavLink>
                                    </NavItem>
                                    :
                                    null
                                }
                            </Nav>
                            <TabContent activeTab={currentTab}>
                                <TabPane tabId="1">
                                    <center>
                                    <RenderImage detail={tw.true1.detail} />
                                    <RenderName name={tw.true1.name} slot={tw.true1.slot} />
                                    <RenderAll 
                                    skill={tw.true1.skill} skillbreak={tw.true1.skillbreak} passive={tw.true1.passive} trueReview={trueReview ? trueReview.trueweapon.true1 : false} />
                                    </center>
                                </TabPane>
                            </TabContent>
                            <TabContent activeTab={currentTab}>
                                <TabPane tabId="2">
                                    <center>
                                    <RenderImage detail={tw.true2.detail} />
                                    <RenderName name={tw.true2.name} slot={tw.true2.slot} />
                                    <RenderAll skill={tw.true2.skill} skillbreak={tw.true2.skillbreak} passive={tw.true2.passive} trueReview={trueReview ? trueReview.trueweapon.true2 : false} />
                                    </center>
                                </TabPane>
                            </TabContent>
                            {
                                tw.true3 ? 
                                <TabContent activeTab={currentTab}>
                                    <TabPane tabId="3">
                                        <center>
                                        <RenderImage detail={tw.true3.detail} />
                                        <RenderName name={tw.true3.name} slot={tw.true3.slot} />
                                        <RenderAll skill={tw.true3.skill} skillbreak={tw.true3.skillbreak} passive={tw.true3.passive} trueReview={trueReview ? trueReview.trueweapon.true3 : false} />
                                        </center>
                                    </TabPane>
                                </TabContent>
                                : null
                            }
                        </>
                        : 
                        <>
                            <center>
                                {
                                    tw?.detail ? 
                                    <RenderImage detail={tw.detail} />
                                    :
                                    <RenderImage detail={jp.detail} />
                                }
                                {
                                    tw?.name ?
                                    <RenderName name={tw.name} slot={tw.slot} />
                                    :
                                    <RenderName name={jp.name} slot={jp.slot} />
                                }
                                
                            </center>
                            {
                                jp ? 
                                <center>
                                    <p className="gs-unit-detail__note"><i><b>This unit has different stats for each server. Please select the server you want to view the stats for.</b></i></p>
                                    <Nav pills justified className="gs-tabs gs-tabs--compact">
                                        <NavItem>
                                        <NavLink className={classnames({ active: serverTab === '1' })}
                                            onClick={() => {serverToggle('1')}} >
                                                <span style={{userSelect: "none"}}>Global</span>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink className={classnames({ active: serverTab === '2' })}
                                                        onClick={() => {serverToggle('2')}} >
                                                <span style={{userSelect: "none"}}>Japan</span>
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    <TabContent activeTab={serverTab} >
                                        <TabPane tabId="1">
                                            {
                                                tw ? <RenderAll skill={tw.skill} skillbreak={tw.skillbreak} passive={tw.passive} trueReview={trueReview.trueweapon} /> 
                                                : 
                                                <TrueWeaponEmpty
                                                    title="Not on Global yet"
                                                    description="This unit is on Global, but its True Weapon is currently Japan-only. Switch to the Japan tab above to view it."
                                                />
                                            }
                                            
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <RenderAll skill={jp.skill} skillbreak={jp.skillbreak} passive={jp.passive} trueReview={trueReview.trueweapon} />
                                        </TabPane>
                                    </TabContent>
                                </center>
                                :
                                <>
                                    <RenderAll detail={tw.detail} slot={tw.slot} name={tw.name} 
                                        skill={tw.skill} skillbreak={tw.skillbreak} passive={tw.passive} trueReview={trueReview.trueweapon} />
                                </>
                                
                            }
                            
                        </>
                    }
                    
                </>
            : (
                <TrueWeaponEmpty
                    title="No True Weapon"
                    description="This unit doesn’t have a True Weapon. You can still review its skills and passives on the Stats tab."
                    actionLabel="View Stats"
                    onAction={onViewStats}
                />
            )}
            </Container>
        </div>
        
    )
    
}

function TrueWeaponEmpty({ title, description, actionLabel, onAction }) {
    return (
        <div className="gs-empty-state gs-empty-state--inline gs-unit-true-empty" role="status">
            <h2>{title}</h2>
            <p>{description}</p>
            {onAction && actionLabel ? (
                <div className="gs-empty-state__actions">
                    <button type="button" className="gs-btn" onClick={onAction}>
                        {actionLabel}
                    </button>
                </div>
            ) : null}
        </div>
    );
}

const RenderAll = ({ skill, skillbreak, passive, trueReview = false }) => {
    //Review Button Toggle
    const [review, setReview] = useState(false)

    return (
        <center>
            {trueReview &&
                <button type="button" className="gs-btn gs-btn--ghost gs-unit-review-toggle" onClick={() => setReview(!review)}>
                    { review ?  <>Hide Review</>  : <>Show Review</>}
                
                </button> 
            }
            <RenderSkill skillbreak={skillbreak} skill={skill} review={trueReview} isReview={review} />
            <RenderPassive passive={passive} review={trueReview} isReview={review} />
        </center>
    )
}
const RenderImage = ({ detail }) => {
    return (
        <div className="gs-unit-detail-art">
            <SkeletonImage
                src={detail}
                alt=""
                className="gs-unit-detail-art__img"
                frameClassName="gs-skeleton-frame--detail"
                loading="lazy"
            />
        </div>
    )
}

const RenderName = ({ slot, name }) => {
    return (
        <Row className="gs-unit-true__name">
            <strong><h1><Media src={slot} />True "{name}"<Media src={slot} /></h1></strong>
        </Row>
    )
}

const RenderSkill = ({ skill, skillbreak, review, isReview }) => {
    return (
        <Row className="gs-unit-block">
            <h3 className="gs-unit-section-title">SKILL</h3>
            <center><p>{skill}&nbsp;<Badge className="gs-badge gs-badge--accent" pill>{skillbreak} BREAK</Badge></p></center>
            { 
                isReview && review.skill && <UnitReviews review={review.skill} />
            }
        </Row>
    )
}

const RenderPassive = ({ passive, review, isReview }) => {
    return (
        <Row className="gs-unit-block">
            <h3 className="gs-unit-section-title">PASSIVE</h3>
            <List type="unstyled" className="gs-unit-passive-list">
                <li>{passive.ability1}</li>
                { 
                    isReview && review && <UnitReviews review={review.ability1} />
                }
                { passive.ability2 && 
                    <>
                        <li>{passive.ability2}</li> 
                        { 
                            isReview && review && <UnitReviews review={review.ability2} />
                        }
                    </>
                }
                { passive.ability3 && 
                    <>
                        <li>{passive.ability3}</li> 
                        { 
                            isReview && review && <UnitReviews review={review.ability3} />
                        }
                    </>
                }
                { passive.ability4 && 
                    <>
                        <li>{passive.ability4}</li> 
                        { 
                            isReview && review && <UnitReviews review={review.ability4} />
                        }
                    </>
                }
            </List>
        </Row>
    )
}
